/**
 * Componente utilitário para exibir os links de paginação
 */

import { 
	Component, 
	Input, 
	OnInit, 
	Output, 
	EventEmitter 
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'yara-pagination',
	templateUrl: 'pagination.component.html'
})

export class YaraPaginationComponent implements OnInit {
	public static readonly TOTAL_PAGS_PADRAO: number = 10;
	public static readonly PAG_PADRAO: number = 0;
	public static readonly REG_PADRAO: number = 0;
	public static readonly ADJACENTES_PADRAO: number = 3;

	@Input() qtdPorPagina: number;
	@Input() totalRegistros: number;
	@Input() qtdAdjacentes: number;
	@Output() onPaginate: EventEmitter<number> = new EventEmitter<number>();

	pagina: number;
	paginaDestino: number;
	paginas: Array<number>;
	exibirProximo: boolean;
	qtdPaginas: number;

	constructor(private route: ActivatedRoute) {
	}

	ngOnInit() {
		this.qtdAdjacentes = this.qtdAdjacentes || YaraPaginationComponent.ADJACENTES_PADRAO;
		this.qtdPorPagina = this.qtdPorPagina || YaraPaginationComponent.TOTAL_PAGS_PADRAO;
		this.pagina = +this.route.snapshot.queryParams['pagina'] || YaraPaginationComponent.PAG_PADRAO;
		this.totalRegistros = this.totalRegistros || YaraPaginationComponent.REG_PADRAO;
		this.qtdPaginas = Math.ceil(this.totalRegistros / this.qtdPorPagina);
		this.gerarLinks();
	}

    ngOnChanges(changes) {
		// Recarrega as páginas quando o numero de registros por página muda
		if (changes.qtdPorPagina) {
			this.pagina = 0;
			this.paginaDestino = 0;
            this.ngOnInit();
            this.gerarLinks();
		}

		// Recarrega as páginas quando o total de registros muda
        if (changes.totalRegistros) {
            this.pagina = 0;
            this.ngOnInit();
            this.gerarLinks();
        }
    }

	/**
	 * Gera os links de paginação.
	 */
	gerarLinks() {
		this.exibirProximo = this.qtdPaginas - 1 !== this.pagina;
		this.paginas = [];
		let iniAdjacente = (this.pagina - this.qtdAdjacentes <= 0) ? 1 : 
				(this.pagina - this.qtdAdjacentes);
		let fimAdjacente = (this.pagina + this.qtdAdjacentes >= this.qtdPaginas) ? 
				this.qtdPaginas : (this.pagina + this.qtdAdjacentes);
		for (let i=iniAdjacente; i<=fimAdjacente; i++) {
			this.paginas.push(i);
		}
	}

	/**
	 * Método responsável por chamar o Emitter de 
	 * paginação.
	 *
	 * @param number pagina
	 * @param any $event número da página a ser exibida.
	 */
	paginar(pagina: number, $event: any, goPage) {
		if (!goPage) {
			this.paginaDestino = undefined;
		}		
		$event.preventDefault();
		this.pagina = pagina;
		this.gerarLinks();
		this.onPaginate.emit(pagina);
	}

	/* Faz o submit do gotopage ao pressionar Enter */
	goToPageFocus($event: any) {
		if ($event.keyCode === 13) {
			$("#searchByPage").trigger("click");
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/pagination/pagination.component.ts